var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(-1018 -606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(1018 606)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hr",
    transform: "translate(994.042 608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(28.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M151.982,13.14H129.865V10.79A10.79,10.79,0,0,1,140.655,0h.537a10.79,10.79,0,0,1,10.79,10.79Z",
    transform: "translate(-119.425)",
    fill: "#5d5260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M221.354,0h-.537a10.876,10.876,0,0,0-1.54.11,10.792,10.792,0,0,1,9.25,10.68v2.35h3.616V10.79A10.79,10.79,0,0,0,221.354,0Z",
    transform: "translate(-199.587)",
    fill: "#4b3f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M71.954,308.374v8.233h-43v-8.128a7.737,7.737,0,0,1,4.736-7.131l16.762-7.288,16.9,7.242A7.734,7.734,0,0,1,71.954,308.374Z",
    transform: "translate(-28.958 -263.636)",
    fill: "#b8b6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(8.803 13.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M185.361,275.664c-3.275,0-5.931-.642-5.931-3.917v-6.863h11.861v6.863C191.291,275.022,188.636,275.664,185.361,275.664Z",
    transform: "translate(-172.666 -250.619)",
    fill: "#e2a876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M329.676,132.68h-1.847v-5.669h1.847a1.426,1.426,0,0,1,1.425,1.425v2.819A1.425,1.425,0,0,1,329.676,132.68Z",
    transform: "translate(-305.712 -127.011)",
    fill: "#e2a876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M115.474,132.68h1.847v-5.669h-1.847a1.425,1.425,0,0,0-1.425,1.425v2.819A1.425,1.425,0,0,0,115.474,132.68Z",
    transform: "translate(-114.049 -127.011)",
    fill: "#e2a876"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(7.77 46.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M105.667,451.895v5.5h-1.6v-5.5a.8.8,0,1,1,1.6,0Z",
    transform: "translate(-104.066 -451.094)",
    fill: "#d2d2ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M164.508,95.235a9.422,9.422,0,1,1-18.845,0V88.011a4.609,4.609,0,0,1,1.034-2.83,4.543,4.543,0,0,1,2.258-1.417c2.7-.779,3.7,1.449,6.762,1.3,2.791-.138,3.53-2.067,5.7-1.419a4.334,4.334,0,0,1,3.091,4.368Q164.508,91.623,164.508,95.235Z",
    transform: "translate(-133.589 -74.871)",
    fill: "#ecbd83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M214.848,382.925h-5.715l2.505-14.469.032-.184a.315.315,0,0,1,.2-.241l.124.109.124-.109a.315.315,0,0,1,.2.241l.032.184Z",
    transform: "translate(-190.493 -329.955)",
    fill: "#5d5260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M155.088,324.168l-.352.316-3.25,2.913a1.286,1.286,0,0,1-1.967-.309l-3.854-6.585,3.494-1.519,5.806,5.074Z",
    transform: "translate(-133.59 -285.984)",
    fill: "#a09eef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M246.2,320.142l-3.882,6.632a1.285,1.285,0,0,1-1.966.309l-3.25-2.913-.353-.316.124-.109,5.808-5.111Z",
    transform: "translate(-215.254 -285.669)",
    fill: "#a09eef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M342.65,415.163H329.6a1.489,1.489,0,0,1-1.489-1.489v-8.2a1.489,1.489,0,0,1,1.489-1.489h13.05a1.489,1.489,0,0,1,1.489,1.489v8.2A1.489,1.489,0,0,1,342.65,415.163Z",
    transform: "translate(-268.202 -362.192)",
    fill: "#ccf49f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(62.287 43.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M420.726,429.268a2.182,2.182,0,0,0,1.409-2.018,2.22,2.22,0,0,0-2.255-2.177h-1.409a.8.8,0,0,0-.8.8v5.3a.8.8,0,1,0,1.6,0v-1.133l1.462,1.662a.8.8,0,1,0,1.2-1.058Zm-.846-2.594a.581.581,0,1,1,0,1.152l-.6,0c0-.222,0-.44,0-.578,0-.118,0-.343,0-.576Z",
    transform: "translate(-410.784 -425.073)",
    fill: "#95d5a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M355.58,425.073a.8.8,0,0,0-.8.8v1.757h-2.065v-1.757a.8.8,0,1,0-1.6,0v5.3a.8.8,0,1,0,1.6,0v-1.939h2.065v1.939a.8.8,0,1,0,1.6,0v-5.3A.8.8,0,0,0,355.58,425.073Z",
    transform: "translate(-351.114 -425.073)",
    fill: "#95d5a4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.d94ed68155ce01b5c150066a0f75e324.svg";
export { ForwardRef as ReactComponent };